import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack } from '@mui/material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: "60%",
    maxWidth: 550,
    minWidth: 300,
    maxHeight: 650,
    p: 3,
    borderRadius: 1,
    boxShadow: 24,
    overflowX: "auto",
};

export default function ConfirmModal(props) {

    return (
        <>
            <Modal
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box sx={style} justifyItems='center'>

                    <Typography
                        // alignContent='center' 
                        textAlign='center'
                        sx={{ mt: 2, pb: 2 }}>
                        {props.message}
                    </Typography>
                    <Typography
                        textAlign='center'
                        sx={{ mt: 2, pb: 2 }}>
                        {props.content}
                    </Typography>

                    <Stack direction='row' style={{ justifyContent: 'space-evenly', paddingTop: '10%' }}>
                        <Button onClick={e => {props.handleFunction(); props.handleClose(e)}} variant='outlined' style={{ background: '#FFC904' }}>
                            Yes
                        </Button>
                        <Button onClick={props.handleClose} variant='outlined' style={{ background: '#FFC904' }}>
                            No
                        </Button>
                    </Stack>

                </Box>
            </Modal>
        </>
    );
}
